<template>
  <div>
    <!-- Campaign Contents -->
    <div
      class="row flex-row flex-nowrap justify-content-center"
      style="overflow-x: hidden"
    >
      <!-- Left Side Card 
      <div class="card shadow customs-card mx-2">
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">|</p>
        </div>
      </div>-->

      <!-- Content Card -->
      <div class="card shadow customs-card mx-2">
        <!-- Campaign Ended Label -->
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">
            キャンペーンは終了しました
          </p>
        </div>

        <div class="card-body p-5 d-flex align-items-center justify-content-center">
          <!-- Campaign Image -->
          <div class="row">
            <div class="col-6 p-0 mx-auto">
              <img
                src="@/assets/img/campaign/campaign_ended.png"
                alt="Campaign Ended"
                class="img-fluid mx-auto d-block mh-100"
              />
            </div>
          </div>
        </div>

        <div class="card-footer border-0 mb-4 background-transparent">
          <p class="text-center text text-color mb-0">
            申し訳ございません。<br />
            こちらのキャンペーンは終了しました。<br />
            またのご応募をお待ちしております。<br />
          </p>
        </div>
      </div>

      <!-- Right Side Card 
      <div class="card shadow customs-card mx-2">
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">|</p>
        </div>
      </div>-->
    </div>

    <!-- Cautions Label and Cautions Details -->
    <cautions :cautions="cautions"></cautions>
  </div>
</template>

<script>
import { getCampaignCautions } from "@/utils/campaign";

import Cautions from "@/components/Cautions.vue";

export default {
  components: {
    Cautions,
  },
  data() {
    return {
      cautions: "",
    };
  },
  created() {
    this.cautions = getCampaignCautions();
  },
};
</script>

<style scoped></style>
